import { render } from "./BlogFile.vue?vue&type=template&id=ce68d2d0&scoped=true"
import script from "./BlogFile.vue?vue&type=script&lang=js"
export * from "./BlogFile.vue?vue&type=script&lang=js"

import "./BlogFile.vue?vue&type=style&index=0&id=ce68d2d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce68d2d0"]])

export default __exports__